import i18nFactory from '@yandex-int/i18n';

import { CryptaInterestTypeWeb } from '../../typings/graphql-grid';
import { UserProfileCondition } from '../../typings/userProfileRetargeting';
import { UserProfileRetargetingConditionGoalType } from '../../typings/userProfileRetargeting';

import * as keyset from './UserProfileHelpers.i18n';

const i18n = i18nFactory(keyset);

export function getCryptaInterestTypeText(type: CryptaInterestTypeWeb): string {
    switch (type) {
        case CryptaInterestTypeWeb.all:
            return i18n('interest-type-all');
        case CryptaInterestTypeWeb.long_term:
            return i18n('interest-type-long-term');
        case CryptaInterestTypeWeb.short_term:
            return i18n('interest-type-short-term');
        default:
            throw Error(`unsupported Type ${type}`);
    }
}

export function getUserProfileConditionTitle(
    key: string,
    type: UserProfileRetargetingConditionGoalType,
    interestType: CryptaInterestTypeWeb | null
): string {
    switch (type) {
        case UserProfileRetargetingConditionGoalType.INTERESTS:
            const interestTypeText = interestType ? `(${getCryptaInterestTypeText(interestType)})` : '';

            return `${i18n('interests')}${interestTypeText}`;
        default:
            return key;
    }
}

export function getUserProfileConditions(conditions: Array<UserProfileCondition>, isCopyText: boolean): string {
    const resultUserProfileConditions = conditions.map(condition => {
        const { key, type, interestType, values } = condition;
        const title = `${getUserProfileConditionTitle(key, type, interestType)}:`;
        const description = values.join(', ');

        return `${title} ${description}`;
    });

    return resultUserProfileConditions.join(isCopyText ? '\n' : '; ');
}

// порядок отображения условий для профиля пользователя
export const orderByTypeUserProfileConditions = [
    UserProfileRetargetingConditionGoalType.SOCIAL_DEMO,
    UserProfileRetargetingConditionGoalType.FAMILY,
    UserProfileRetargetingConditionGoalType.BEHAVIORS,
    UserProfileRetargetingConditionGoalType.AUDIO_GENRES,
    UserProfileRetargetingConditionGoalType.INTERESTS
];
